import React, { useRef } from 'react';

import useScrollBox from './hook/use-scroll-box';

type ScrollBoxProps = {
  children: any;
};

const ScrollBox = (props: ScrollBoxProps) => {
  const { children } = props;
  const scrollWrapperRef = useRef();
  const { isDragging } = useScrollBox(scrollWrapperRef);

  return (
    <div className="scroll-box">
      <div className="scroll-box__wrapper" ref={scrollWrapperRef}>
        <div className="scroll-box__container" role="list" style={{ pointerEvents: isDragging ? 'none' : undefined }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ScrollBox;
